module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ef.681f4b3d.png";